<template>
    <div class="component-playback">
      <img
        class="playback-bg"
        src="https://p2.ssl.qhimg.com/t110b9a93016912f3957d31fc56.png"
        alt=""
      />
      <!-- <Header /> -->
      <div class="playback-content">
        <div style="width: 100%;height: 258px" id="playback-video-h5">
          <play-show :data="currentData" type="h5" v-if="showVideo"></play-show>
          <div class="playback-none" v-else></div>
        </div>
        <div style="width: 100%;height: 320px;margin-top: 16px">
          <play-tablist type="h5" @playVideo="playVideo"></play-tablist>
        </div>
      </div>
    </div>
  </template>
  
  <script setup>
  import { nextTick, ref, onMounted } from 'vue'
//   import Header from '@/components/common/2024/header.vue'
  import PlayShow from './play-show.vue'
  import PlayTablist from './play-tablist.vue'

  onMounted(() => {
  //整体缩放
    let resizeWindow = function (){
        let root = document.getElementById("playback-video-h5");
        if(window.innerWidth<430){
            let fangdabili = window.innerWidth / 430;
            root.style.height = `${263*fangdabili}px`     
        }else{      
            // root.style.height = `` 
        }
    }
    resizeWindow()
    window.addEventListener("resize",()=>{
        resizeWindow()
    })
})
  
  let showVideo = ref(false)
  
  const currentData = ref({})
  const playVideo = (data) => {
    currentData.value = data
    showVideo.value = false
    nextTick(() => {
      showVideo.value = true
    })
  }
  
  
  </script>
  
  <style lang="scss" scoped>
  .component-playback {
  //   min-height: 100vh;
    background: #f3f3f3;
    padding-top: 88px;
    .playback-bg {
      width: 100%;
      position: absolute;
      top: 0;
    }
    .playback-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 90%;
      margin: 0 auto;
      .playback-none{
        width: 100%;
        height: 100%;
        background: #ffffff;
        border-radius: 16px;
      }
    }
  }
  </style>
   